<template>
  <div v-if="attach && attach.length > 0" style="position: relative;">
    <el-tabs class="attachments-type" type="card" v-model="activeTab">
      <el-tab-pane :label="`最近简历(${(最新简历 || []).length})`" name="last" style="padding-top:25px">
        <FileTable
          v-if="最新简历 && 最新简历.length > 0"
          ref="FileTable-最新简历"
          :rid="rid"
          :files="最新简历 || []"
          :on-delete="deleteAttachment"
          :on-mark="markAttachment"
          :paginate="false"
          :width="width || '100%'"
          :height="height || '100%'"
      /></el-tab-pane>
      <el-tab-pane :label="`完整推荐报告(${(完整推荐报告 || []).length})`" name="full" style="padding-top:25px"
        ><FileTable
          v-if="完整推荐报告 || []"
          ref="FileTable-完整推荐报告"
          :rid="rid"
          :files="完整推荐报告"
          :on-delete="deleteAttachment"
          :on-mark="markAttachment"
          :paginate="false"
          :width="width || '100%'"
          :height="height || '100%'"
      /></el-tab-pane>
      <el-tab-pane :label="`半成品推荐报告(${(半成品推荐报告 || []).length})`" name="half" style="padding-top:25px"
        ><FileTable
          v-if="半成品推荐报告 || []"
          ref="FileTable-半成品推荐报告"
          :rid="rid"
          :files="半成品推荐报告"
          :on-delete="deleteAttachment"
          :on-mark="markAttachment"
          :paginate="false"
          :width="width || '100%'"
          :height="height || '100%'"
      /></el-tab-pane>
      <el-tab-pane :label="`猎聘/领英插件(${(插件 || []).length})`" name="liepin" style="padding-top:25px"
        ><FileTable
          v-if="插件 || []"
          ref="FileTable-最新简历"
          :rid="rid"
          :files="插件"
          :on-delete="deleteAttachment"
          :on-mark="markAttachment"
          :paginate="false"
          :width="width || '100%'"
          :height="height || '100%'"
      /></el-tab-pane>
      <el-tab-pane :label="`全部附件(${attach.length})`" name="all" style="padding-top:25px"
        ><FileTable
          ref="FileTable-全部附件"
          :rid="rid"
          :files="attach"
          :on-delete="deleteAttachment"
          :on-mark="markAttachment"
          :paginate="false"
          :width="width || '100%'"
          :height="height || '100%'"
        />
      </el-tab-pane>
    </el-tabs>
    <el-button
      v-if="withParse && attach && attach.length > 0"
      style="position: absolute;right:10px;top:47px;"
      size="mini"
      round
      type="primary"
      @click="showParse"
    >
      解析简历
    </el-button>
  </div>
</template>
<script>
import { FileTable } from '../../../file'

export default {
  components: { FileTable },
  props: {
    rid: String,
    attach: Array,
    deleteAttachment: Function,
    markAttachment: Function,
    showParse: Function,
    withParse: Boolean,
    height: Number || String,
    width: Number || String,
  },
  data() {
    return {
      activeTab: 'last'
    }
  },
  computed: {
    最新简历() {
      const validCvs = this.attach
        .filter(a => ['原始简历', 'cv'].includes(a.type))
        .sort((a, b) => (!b.createdAt || a.createdAt > b.createdAt ? -1 : 1))
      return validCvs.length === 0 ? [] : [validCvs[0]]
    },
    完整推荐报告() {
      return this.attach.filter(a => /** a.type === '推荐报告' && **/ a.isFinal)
    },
    半成品推荐报告() {
      return this.attach.filter(a => a.type === '推荐报告' && (!a.isFinal || a.isHalf))
    },
    插件() {
      return this.attach.filter(
        a =>
          /from插件/.test(a.originalname) ||
          (a.uploader &&
            Array.isArray(a.uploader) &&
            (a.uploader.includes('liepin') || a.uploader.includes('plugin'))) ||
          a.简历编号,
      )
    },
  },
  async mounted() {
    const defaultActiveTab = this.$route.query.subltab || ''
    if (defaultActiveTab) this.activeTab = defaultActiveTab
    // const validCvs = this.attach
    //   .filter(a => ['原始简历', 'cv'].includes(a.type))
    //   .sort((a, b) => (!b.createdAt || a.createdAt > b.createdAt ? -1 : 1))
  },
  methods: {},
}
</script>
<style>
.attachments-type .el-tabs__item {
  font-size: 10px;
  padding-left: 5px;
  padding-right: 5px;
}
</style>
